module.exports = __webpack_public_path__ + "static/seamless-5-1c9184d30748cd57436dbd20dd031e4b.png";